import { ReportsModal } from '@/shared/components/reports-modal'
import { FiFile, FiUser } from 'react-icons/fi'
import { useLoaderData } from 'react-router-dom'

export const ContractReports = () => {
  const { data: contractReportColumns = [] } = useLoaderData()

  const reportOptions = [
    {
      label: 'Tabla de contratos',
      description:
        'Descarga la información de la tabla de contratos. Puedes seleccionar las columnas',
      value: 'contract',
      icon: FiUser,
      columns: contractReportColumns
    },
    {
      label: 'Listado de documentos',
      description:
        'Descarga el listado de documentos asociados a los contratos',
      value: 'contract_attachments',
      icon: FiFile,
      columns: []
    }
  ]

  return <ReportsModal reportOptions={reportOptions} />
}
